import { Box, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { visuallyHidden } from '@mui/utils';
import { v4 as uuid } from 'uuid';
import { HeadCell } from "..";
import { Order } from "../../../../../components/StyledTableContentRaw";

interface PaymentsTableProps {
  numSelected: number;
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
  heads: HeadCell[];
}

export default function PaymentsTableHead(props: PaymentsTableProps) {
  const {
    order,
    orderBy,
    onRequestSort,
    heads,
  } = props;
  const createSortHandler =
    (property: string) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead style={{ position: 'relative' }}>
      <TableRow>
        {heads.map((headCell) => (
          <TableCell
            key={uuid()}
            padding="none"
            sortDirection={orderBy === headCell.key ? order : false}
          >
            {headCell.key ? (
              <TableSortLabel
                hideSortIcon={orderBy !== headCell.key}
                active={orderBy === headCell.key}
                direction={orderBy === headCell.key ? order : 'asc'}
                onClick={createSortHandler(headCell.key)}
              >
                {headCell.label}
                {orderBy === headCell.key ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc'
                      ? 'sorted descending'
                      : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            ) : (
              headCell.label
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}